import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { Icon } from '@verantos-dev/shared-components';

export const CohortCharacteristicsDataDialogTitle = ({
  onHideDataDialog,
  selectedCharacteristicType,
}: {
  onHideDataDialog: () => void;
  selectedCharacteristicType: string;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mx: 6,
        my: 3,
        mb: 3,
      }}
    >
      <Typography variant="h6">
        <FormattedMessage
          id="projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.drawerTitleType"
          values={{
            type: selectedCharacteristicType,
          }}
        />
      </Typography>
      <Box onClick={onHideDataDialog} sx={{ cursor: 'pointer', width: '24px', height: '24px' }}>
        <Icon id="cohortCharacteristicsCloseChart" icon="close" width={24} height={24} />
      </Box>
    </Box>
  );
};
